import { render } from "./VoteItemControl.vue?vue&type=template&id=0564c1c9&scoped=true"
import script from "./VoteItemControl.vue?vue&type=script&lang=js"
export * from "./VoteItemControl.vue?vue&type=script&lang=js"

import "./VoteItemControl.vue?vue&type=style&index=0&id=0564c1c9&scoped=true&lang=css"

import exportComponent from "C:\\Mobile\\voting2024\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0564c1c9"]])

export default __exports__